import { BaseService } from "mrb/core";
import { NakiNigunAnalyticsApiRouteService } from "common/services";

class NakiNigunAnalyticsService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new NakiNigunAnalyticsApiRouteService());
    }

    getNakiNigunListenersStats(abortSignal = null) {
        const url = this.routeService.getNakiNigunListenersStats();
        return this.apiClient.get(url, null, abortSignal);
    }

    getTrendingAlbumsForProducer(filter, abortSignal = null) {
        const url = this.routeService.getTrendingAlbumsForProducer(filter);
        return this.apiClient.get(url, null, abortSignal);
    }

    getTrendingNakiNigunAlbums(filter, abortSignal = null) {
        const url = this.routeService.getTrendingNakiNigunAlbums(filter);
        return this.apiClient.get(url, null, abortSignal);
    }

    getTrendingAlbumsTotalStreamsForProducer(filter, abortSignal = null) {
        const url = this.routeService.getTrendingAlbumsTotalStreamsForProducer(filter);
        return this.apiClient.get(url, null, abortSignal);
    }

    getNakiNigunAlbumActivity(id, options, abortSignal = null) {
        const url = this.routeService.getNakiNigunAlbumActivity(id, options);
        return this.apiClient.get(url, null, abortSignal);
    }

    getNakiNigunAlbumSummary(id, options, abortSignal = null) {
        const url = this.routeService.getNakiNigunAlbumSummary(id, options);
        return this.apiClient.get(url, null, abortSignal);
    }
}

export default NakiNigunAnalyticsService;
